module.exports = __webpack_public_path__ + "assets/img/online-verification.db4e207b.png";